import Errors from 'components/errors/Errors'
import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useDispatch } from 'react-redux'
import { setError } from 'store/reducers/errors'
import logger from 'utils/logger'

export interface ErrorBoundaryWrapperProps {
  children: React.ReactNode
}

const ErrorBoundaryWrapper = ({ children }: ErrorBoundaryWrapperProps) => {
  const dispatch = useDispatch()
  
  const handleError = (error: Error) => {
    logger.noticeError(`Errorboundary: Error (${error}).`)
    dispatch(setError(0))
  }

  return (
    <ErrorBoundary fallback={<Errors errorCode={0}/>} onError={handleError}>
      {children}
    </ErrorBoundary>
  )
}

export default ErrorBoundaryWrapper